import React from 'react';
import * as S from './styles';

const ImageContainer = (props = {}) => <S.ImageContainer order={props.order}>{props.children}</S.ImageContainer>;

export default ImageContainer;
